"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_JSON = 'UPDATE_JSON';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kZWwuYWN0aW9ucy50eXBlcy5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL3N0b3JlL21vZGVsLmFjdGlvbnMudHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBYSxRQUFBLFdBQVcsR0FBRyxhQUFhLENBQUEifQ==